export enum PrinterType {
  Bluetooth = 'BLUETOOTH',
  Wifi = 'WIFI',
}
